import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { fetchUserInformation, UserInformationResponse } from '../api/userInformation/fetchUserInformation';
import { useToastContext } from './contexts/useToastContext';

export const useUserInformationFetch = (enabled = true) => {
  const { showToast } = useToastContext();

  const query = useQuery<UserInformationResponse | null>({
    queryFn: fetchUserInformation,
    queryKey: ['user-information'],
    enabled,
  });

  useEffect(() => {
    if (query.isError) {
      showToast('Erro ao realizar a requisição.', 'error');
    }
  }, [query.isError, showToast]);

  return query;
};
